import { Component, Prop, h } from '@stencil/core';
@Component({
  tag: 'dynamic-entry-error',
  styleUrl: 'dynamic-entry-error.css',
})
export class DynamicEntryError {
  @Prop() errorMessage: string = '';
  @Prop() hasError: boolean = false;
  @Prop() hiddenMode: boolean = false;

  render() {
    const shouldDisplayError = this.hasError && this.errorMessage;
    const classList = {
      'dynamic-entry-error': shouldDisplayError && this.hiddenMode,
      'opacity-0': !shouldDisplayError && !this.hiddenMode,
      'dynamic-entry-error-collapsed': !shouldDisplayError && this.hiddenMode,
    };
    return (
      <div>
        <span class={classList}>
          <svg-icon icon="icon-alert" width="1em" height="1em" class="mr-2 dynamic-entry-error-icon"></svg-icon>
          {this.errorMessage}
        </span>
      </div>
    );
  }
}
